import './phone-additional-information-view.ajscss';

import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IComponentController, IComponentOptions } from 'angular';

import { Configuration } from '@contact/upgrade';

import templateUrl from './phone-additional-information-view.template.html';

class AdditionalInformation {
  public order: number;
  public title: string;
  public value: string;
}

class PhoneAdditionalInformationViewCtrl implements IComponentController {
  // Regular expression to find the prefixed optional content, i.e. starting with a prefix like P888_ (eg P1_, P8_, P24_, ...)
  private readonly PREFIX_PATTERN = new RegExp('^P([0-9]+)_([a-zA-Z0-9s+]+)');
  public commentsPanelOpened: boolean = false;
  public additionalInformationList: AdditionalInformation[] = [];
  private responseId: string;
  contextCommentAdded: boolean = false;

  constructor(private readonly configuration: Configuration, private readonly contactDeprecatedService: IContactDeprecatedService) {}

  $onInit(): void {
    let prefixedContext: AdditionalInformation;
    this.contactDeprecatedService.getContact(this.responseId).then(contact => {
      let prefixedOptionalContentMaxNb = this.configuration.phone?.additionalInformation?.maxWithPrefix ?? 25;
      for (let property in contact.context) {
        // Check if the property is prefixed (by P + number + _)
        const prefixedPropertyMatch = this.PREFIX_PATTERN.exec(property);

        if (prefixedPropertyMatch != null) {
          let prefixNumber = Number(prefixedPropertyMatch[1]);
          // If the prefix is greater than the maximum authorized, ignore it
          if (prefixNumber <= prefixedOptionalContentMaxNb) {
            this.additionalInformationList.push({
              // The order can be found in the first group of the regexp
              order: prefixNumber,
              // Title is given by the second group of the regexp
              title: prefixedPropertyMatch[2],
              // If value is empty, then put an hyphen instead to avoid issues
              value: contact.context[property] || '-',
            });
          }
        } else if (property.startsWith('CONTEXT_')) {
          prefixedContext = {
            order: 10000,
            title: property,
            value: contact.context[property],
          };
          this.additionalInformationList.push(prefixedContext);
        } else if (!!contact.campaign?.contactCampaignTextMessage && !this.contextCommentAdded) {
          prefixedContext = {
            order: -1, // force this comment item to be the first on the additionalInformationList after sorting
            title: 'CONTEXT_COMMENT',
            value: contact.campaign?.contactCampaignTextMessage,
          };
          this.additionalInformationList.push(prefixedContext);
          this.contextCommentAdded = true;
        }
      }

      if (this.additionalInformationList.length > 0) {
        // Sort the optional contents by their order
        this.additionalInformationList.sort((info1, info2) => info1.order - info2.order);

        const toogleBar: HTMLElement = window.document.getElementsByClassName('expander')[0] as HTMLElement;
        setTimeout(() => {
          toogleBar.click();
        }, 0);

        $('#Area-WorkZone-Expand').removeClass('masked');
      }
    });
  }
}

export class PhoneAdditionalInformationView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['configuration', 'contactDeprecatedService', PhoneAdditionalInformationViewCtrl];
}

export default 'phoneAdditionalInformationView';
